import type { ReactNode } from 'react';
import { type Control, useWatch } from 'react-hook-form';

export type FormIfFieldProps = {
  control?: Control;
  field: string;
  value?: unknown;
  condition?: (fieldValue: unknown) => boolean;
  children: ReactNode;
  fallback?: ReactNode;
};

export const FormIfField = ({
  control,
  field,
  value,
  condition,
  children,
  fallback,
}: FormIfFieldProps) => {
  const fieldValue = useWatch({
    control,
    name: field,
  });

  const shouldShow = condition
    ? condition(fieldValue)
    : value !== undefined
      ? fieldValue === value
      : Boolean(fieldValue);

  if (shouldShow) {
    return children;
  }

  if (fallback !== undefined) {
    return fallback;
  }

  return null;
};

FormIfField.displayName = 'Form.IfField';
